import { MouseEvent } from "react";
import DatePicker from "react-datepicker";
import styles from "./Filters.module.css";
import DeleteBtn from "img/X-symbol-black.svg";
import CloseBtn from "img/X-symbol-white.svg";
import { startOfDay } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import { Dates } from "types/filters";

interface Props {
	onChange: (v: Dates) => void;
	dates: Dates;
	onClose: () => void;
}
const DateFilter = ({ onChange, dates, onClose }: Props) => {
	const setNewDates = (startDate: Date | null, endDate: Date | null) => {
		// Round startDate to the beginning of the day and endDate to the end of day

		let newDates: Dates = {
			startDate: dates.startDate,
			endDate: dates.endDate,
		};

		if (startDate) {
			newDates.startDate = startOfDay(new Date(startDate)).toString();
		} else if (startDate === null) {
			newDates.startDate = null!;
		}
		if (endDate) {
			newDates.endDate = startOfDay(new Date(endDate)).toString();
		} else if (endDate === null) {
			newDates.endDate = null!;
		}

		onChange(newDates);
	};

	const removeStartDate = (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setNewDates(null!, new Date(dates.endDate));
	};
	const removeEndDate = (e: MouseEvent<HTMLButtonElement>) => {
		e.preventDefault();
		setNewDates(new Date(dates.startDate), null!);
	};

	return (
		<div className={styles.dateFilter}>
			<button className={styles.closeBtn} onClick={onClose}>
				<img src={CloseBtn} alt="Close" />
			</button>
			<span className={styles.dateInputLabel}>START DATE</span>
			<div className={styles.datePickerRow}>
				<DatePicker
					selected={new Date(dates.startDate)}
					onChange={(newStartDate) => setNewDates(newStartDate, new Date(dates.endDate))}
				/>
				<button onClick={(e) => removeStartDate(e)}>
					<img src={DeleteBtn} alt="Delete" />
				</button>
			</div>
			<span className={styles.dateInputLabel}>END DATE</span>
			<div className={styles.datePickerRow}>
				<DatePicker
					selected={new Date(dates.endDate)}
					onChange={(newEndDate) => setNewDates(new Date(dates.startDate), newEndDate)}
				/>
				<button onClick={(e) => removeEndDate(e)}>
					<img src={DeleteBtn} alt="Delete" />
				</button>
			</div>
		</div>
	);
};

export default DateFilter;
